import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-ui-coverages-health',
  templateUrl: './ui-coverages-health.component.html',
  styleUrls: ['./ui-coverages-health.component.scss']
})
export class UiCoveragesHealthComponent implements OnInit {

  @Input() sumInsured:any = 100000;
  @Input() addRows:number = 0;

  constructor() { }

  ngOnInit() {
    /* Init dummy rows from Input() */
    for(let i=1;i<this.addRows;i++){ this.addRow() }
  }

  rows = [{id:1}];
  addRow() {
    let objDummy = {id:1};
    this.rows.push(objDummy);
  }
  removeRow(){
    this.rows.pop();
  }

  coverages = [
    {id:4, name:"Premium Waiver"},
    {id:1, name:"Double Accident Benefit"},
    {id:2, name:"Personal Accident"},
    {id:5, name:"Critical Illness"},
    {id:3, name:"Hospitalization & Surgery"},
  ]

}
